import React from 'react';
import b_ from 'b_';
import { Button } from '../Button';
import { Card } from '../Card';
import { Text } from '../Text';
import './DriverDetails.scss';
import { CompatibleProducts } from '../CompatibleProducts';

const b = b_.lock('DriverDetails');

const DriverDetails = ({
  previewText,
  downloadLink,
  description,
  compatibleProducts,
  compatibleSiteProducts,
  fileSize,
  version,
  platforms, // make this field required on backend
  languages
}) => (
  <div className={b()}>
    <div className={b('column')}>
      <Card className={b('specsList')}>
        {fileSize && <Text className={b('specItem')}>{`Размер файла: ${fileSize} Мб`}</Text>}
        {platforms && !!platforms.length && (
          <Text className={b('specItem')}>{`Платформа: ${platforms.join(', ')}`}</Text>
        )}
        {version && <Text className={b('specItem')}>{`Версия: ${version}`}</Text>}
        {languages && !!languages.length && <Text className={b('specItem')}>{`Язык: ${languages.join(', ')}`}</Text>}
      </Card>
      <div className={b('downloadBtns')}>
        {downloadLink.map((link, i) => (
          <Button
            as='a'
            className={b('downloadBtn')}
            href={link}
            key={link}
            target='_blank'
            rel='noopener nofollow'
            size='l'
          >
            {`Скачать${i ? ` с сервера ${i + 1}` : ''}`}
          </Button>
        ))}
      </div>
    </div>
    <div className={b('column')}>
      {!!previewText && <div className={b('description')}>{previewText}</div>}
      {!!description && <div className={b('description')}>{description}</div>}
      <CompatibleProducts
        heading='Подходит к моделям:'
        richProducts={compatibleSiteProducts}
        products={compatibleProducts}
      />
    </div>
  </div>
);

export default DriverDetails;
